import React from "react";
import Breadcrumbs from "app/layout/breadcrumbs";

const ProductNameSection = ({ categories, name }) => {
  return <Breadcrumbs />;
};

export default ProductNameSection;
